// extracted by mini-css-extract-plugin
export var callCard = "_hw-0";
export var callMessageButton = "_hw-1";
export var helpIcon = "_hw-3";
export var helpIconContainer = "_hw-4";
export var verticalDivider = "_hw-2";